import Media from './media';
import Richtext from './richtext';
import Link from './link';

export default class Offerings {
  offerTitle?: Richtext | null;
  backgroundColor: string;
  ctaLinks?: Link[];
  descriptionIsRightSide: boolean;
  offerDescription?: Richtext | null;
  subtitle: string;
  subtitleColor: string;
  backgroundImage?: Media | null;
  image?: Media | null;

  constructor(props: any) {
    this.offerTitle = props.offerTitle ? new Richtext(props.offerTitle) : null;
    this.backgroundColor = props.backgroundColor;
    this.descriptionIsRightSide = props.descriptionSide
      ? props.descriptionSide === 'right'
      : true;
    this.offerDescription = props.offerDescription
      ? new Richtext(props.offerDescription)
      : null;
    this.subtitle = props.subtitle;
    this.subtitleColor = props.subtitleColor;
    this.backgroundImage = props.backgroundImage
      ? new Media(props.backgroundImage)
      : null;
    this.image = props.image ? new Media(props.image) : null;
    this.ctaLinks = props?.ctaLinksCollection?.items || [];
  }
}
